import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OrdenMantenimientoActividadesService {
  private apiUrl = `${environment.apiUrl}/api/ordenes-mantenimiento`;

  constructor(private http: HttpClient) {}

  createMantenimiento(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, payload);
  }

 gestionEstadoActividad(
  idActividad: number,
  estadoId: number,
  orden: any
): Observable<any> {
  return this.http.put<any>(
    `${this.apiUrl}/actividades/${idActividad}/estado`,
    { estadoId,orden }
  );
}
}